/**
 * Un tab per sport sopra un profilo prestativo.
 *
 * Ogni disciplina ha domini, esercizi e tabelle di riferimento propri: sono
 * profili distinti, non filtri dello stesso (decisione D12,
 * docs/shooting/08-atleta-multisport.md). Con un solo sport la barra non
 * compare e la pagina resta identica a prima.
 *
 * Una sola barra per la pagina dell'atleta e per la vista del coach, così le
 * due non divergono.
 *
 * Props:
 *  - sports: array di slug, nell'ordine dell'atleta
 *  - active: lo slug selezionato
 *  - onChange(slug)
 *  - labelFor(slug) -> etichetta (le etichette sono dato admin, non si traducono)
 */
export function SportTabs({ sports = [], active, onChange, labelFor, className = "" }) {
	if (!Array.isArray(sports) || sports.length < 2) return null;
	return (
		<div className={className}>
			<div className="flex gap-1.5 overflow-x-auto pb-1 no-scrollbar border-b border-border">
				{sports.map((sportValue) => (
					<button
						key={`sport_tab_${sportValue}`}
						type="button"
						aria-pressed={active === sportValue}
						onClick={() => {
							if (sportValue !== active) onChange?.(sportValue);
						}}
						className={`shrink-0 px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
							active === sportValue
								? "border-volt text-volt"
								: "border-transparent text-muted-foreground hover:text-foreground"
						}`}
					>
						{labelFor ? labelFor(sportValue) : sportValue}
					</button>
				))}
			</div>
		</div>
	);
}
